
import { mapGetters, mapActions } from "vuex"
import debounce from "lodash/debounce"
import get from "lodash/get"
import set from "lodash/set"
import translitMixin from "@/mixins/translit"
import { fileToBase64 } from "@/utils/file"
// import { storageKeys, getLs, removeLs } from "@/utils/storage"

function recursiveKeys (obj) {
  return Object.keys(obj).flatMap(key =>
    typeof obj[key] === "object" && obj[key]
      ? recursiveKeys(obj[key]).map(innerKey => `${key}.${innerKey}`)
      : key,
  )
}

export default {
  mixins: [translitMixin],

  // middleware: "auth",
  // auth: "guest",

  props: {
    initialData: { type: Object, default: null },
    previousData: { type: Object, default: null },
    isOauth: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
    isColleague: { type: Boolean, default: false },
    colleagueId: { type: String, default: "" },
    token: { type: String, default: undefined },
  },

  data: () => ({
    form: {
      email: "",
      firstName: { ru: undefined, en: "" },
      lastName: { ru: undefined, en: "" },
      patronymic: { ru: undefined, en: "" },
      company: { ru: undefined, en: "" },
      position: { ru: undefined, en: "" },
      phone: "",
      photo: undefined,
      status: "",
      visible: false,
      password: undefined,
      attributes: {
        industryOther: undefined,
        activitySphereOther: undefined,
        readyToInvest: false,
        wantToExhibit: false,
        wantToCompete: false,
        cityOfResidence: "",
        countryOfResidence: "",
        sex: "",
        inn: undefined,
        positionLevel: "",
        website: undefined,
        skCompany: undefined,
        skOrn: undefined,
        companyForBadge: undefined,
        speakerBadgeName: undefined,
        speakerBadgeLastName: undefined,
        speakerBiography: { ru: undefined, en: undefined },
        placeOfBirth: undefined,
        dateOfBirth: undefined,
        passportSeries: undefined,
        passportNumber: undefined,
        passportIssueDate: undefined,
        passportExpireDate: undefined,
        studentPhoto: undefined,
      },
      participationType: "offline",
      citizenship: "",
      activitySphere: "",
      industry: "",
      interests: [],
      agreed: undefined,
      registrationToken: undefined,
      oauth: undefined,
    },
    translitFields: ["lastName", "firstName", "patronymic", "company"]
      .map(k => `form.${k}`),
    apiErr: {},
    suggestedCompanies: [],
    repeatPassword: "",
    isExhibitionModalOpened: false,
    isExhibitionModalShowed: false,
    isLoading: false,
  }),

  async fetch () {
    await this.fetchStatuses()
    await this.fetchTags()
  },

  computed: {
    ...mapGetters("user", ["user", "getStatusesOptions"]),

    ...mapGetters("tags", ["interests"]),
    ...mapGetters("tags", { getTagsOptions_: "getOptions" }),
    activitySpheresOptions () {
      return this.getTagsOptions_(this.$i18n, this.$fmt.localize,
        { key: "activitySpheres" })
    },
    industriesOptions () {
      return this.getTagsOptions_(this.$i18n, this.$fmt.localize,
        { key: "industries" })
    },

    positionLevelOptions () {
      return Object.fromEntries(
        this.$t("registration.positionLevels").map(l => [l, l]))
    },
    statuses () {
      return this.getStatusesOptions(this.$fmt.localize)
    },

    isOffline () {
      return true
      // return this.form.participationType === "offline"
    },
    isRu () {
      return this.form.citizenship === "RU"
    },
    isStudent () {
      return this.form.status === "student"
    },
    isSk () {
      return this.form.status === "skresident"
    },
    hasBadge () {
      return [
        "speaker",
      ].includes(this.form.status)
      // return this.isStatusSpecial &&
      //   ![
      //     "organizer",
      //     "exhibitor",
      //     "contestant",
      //   ].includes(this.form.status)
    },

    specialStatuses () {
      return Object.keys(this.$t("common.specialStatus"))
    },
    isStatusSpecial () {
      return this.specialStatuses.includes(this.form.status)
    },

    companyForBadgeLabel () {
      const { isOffline } = this
      return this.$t(this.isStudent
        ? isOffline
          ? "registration.companyForBadge.offline.student.label"
          : "registration.companyForBadge.online.student.label"
        : isOffline
          ? "registration.companyForBadge.offline.label"
          : "registration.companyForBadge.online.label",
      )
    },
  },

  watch: {
    "form.lastName.en" (lastNameEn) {
      if (this.hasBadge) this.form.attributes.speakerBadgeLastName = lastNameEn
    },
    "form.firstName.en" (firstNameEn) {
      if (this.hasBadge) this.form.attributes.speakerBadgeName = firstNameEn
    },

    "form.citizenship" (citizenship) {
      if (!this.form.attributes.countryOfResidence)
        this.form.attributes.countryOfResidence = citizenship
    },

    isOffline (isOffline) {
      if (!isOffline) {
        this.form.attributes.placeOfBirth = undefined
        this.form.attributes.dateOfBirth = undefined
        this.form.attributes.passportSeries = undefined
        this.form.attributes.passportNumber = undefined
        this.form.attributes.passportIssueDate = undefined
        this.form.attributes.passportExpireDate = undefined
      }
    },

    isRu (isRu) {
      if (!isRu) {
        this.form.lastName.ru = undefined
        this.form.firstName.ru = undefined
        this.form.patronymic.ru = undefined
        this.form.company.ru = undefined
        this.form.attributes.inn = undefined
        this.form.position.ru = undefined
        this.form.attributes.speakerBiography.ru = undefined
      }
    },
    isStudent (isStudent) {
      if (isStudent) {
        this.form.attributes.inn = undefined
        this.form.attributes.positionLevel = undefined
        this.form.position = { ru: undefined, en: undefined }
      }
    },
    isSk (isSk) {
      if (!isSk) {
        this.form.attributes.skCompany = undefined
        this.form.attributes.skOrn = undefined
      }
    },

    "form.attributes.wantToExhibit" (wantToExhibit) {
      if (wantToExhibit && !this.isExhibitionModalShowed && !this.isEdit &&
        !this.isColleague) {
        this.isExhibitionModalOpened = true
        this.isExhibitionModalShowed = true
      }
    },

    "form.attributes.inn" () {
      this.updateSkData()
    },
  },

  created () {
    this.setInitial()
  },

  async mounted () {
    // await this.checkOauth()
    if (this.isColleague) await this.fetchColleagueData()
    else if (this.isEdit) await this.fillFromUser()
    this.setTransliterators()
  },

  methods: {
    get,
    set,

    ...mapActions("user", ["fetchStatuses", "updateUser"]),
    ...mapActions("tags", ["fetchTags"]),

    toggleInterest (id) {
      this.$set(this.apiErr, "interests", undefined)
      const currInterests = this.form.interests
      const total = currInterests.length
      if (currInterests.includes(id)) {
        if (total <= 1) return
        this.form.interests = currInterests.filter(i => i !== id)
      // eslint-disable-next-line no-useless-return
      } else if (currInterests.length >= 5) return
      else this.form.interests.push(id)
    },
    isInterestDisable (id) {
      const { interests } = this.form
      const isOn = interests.includes(id)
      if (isOn) return interests.length <= 1
      return interests.length >= 5
    },

    setPhoto (photoId) {
      this.$set(this.apiErr, "photo", undefined)
      this.form.photo = photoId
    },

    suggestCompanies: debounce(async function (query) {
      this.form.attributes.skOrn = undefined
      this.form.attributes.inn = undefined

      if (!this.isRu || this.isStudent) return
      if (!query) {
        this.suggestedCompanies = []
        return
      }
      const [res, err] = await this.$api.dadata.getCompanies(query)
      if (err) {
        this.suggestedCompanies = []
        console.error(err)
        return
      }
      this.suggestedCompanies = res || []
    }, 300),

    onSuggestedCompanyClick (company) {
      this.form.company.ru = company.title
      this.form.attributes.inn = parseInt(company.inn)
      this.suggestedCompanies = []
    },

    setInitial () {
      const { initialData } = this
      const status = initialData?.status || ""
      if (this.specialStatuses.includes(status))
        this.form.status = status
      const email = initialData?.email || ""
      if (email) this.form.email = email
      this.form.registrationToken = this.token
    },

    getPayload () {
      const form = { ...this.form };

      ["industry", "activitySphere"].forEach((k) => {
        if (form[k] === "other" && form.attributes[`${k}Other`])
          form[k] = undefined
      })

      if (!form.attributes.website) form.attributes.website = undefined
      if (!form.attributes.inn) form.attributes.inn = undefined

      return form
    },

    async fill (data, proxyPhoto = false) {
      const prev = data
      const curr = this.form
      const skipKeys = [
        "photo",
        "status",
        "participationType",
        "activitySphere",
        "industry",
        "agreed",
        "oauth",
      ]
      const prevKeys = recursiveKeys(prev)
        .filter(k => !skipKeys.includes(k))
      const currKeys = recursiveKeys(curr)
        .filter(k => !skipKeys.includes(k))

      const prevPhone = prev.attributes?.phone
      if (prevPhone) curr.phone = prevPhone

      prevKeys.forEach((k) => {
        if (!currKeys.includes(k)) return
        const v = get(prev, k)
        if (v) set(curr, k, v)
      })

      const { isEdit, colleagueId } = this
      if (isEdit || colleagueId) {
        this.form.interests = prev.interests.map(i => i.id)
        this.form.status = prev.status.alias
        // this.form.participationType = prev.participationType
        this.form.activitySphere = prev.activitySphere?.id ?? "other"
        this.form.industry = prev.industry?.id ?? "other"
      }

      const { photo } = prev
      if (photo) {
        await this.$nextTick()
        const { cropper } = this.$refs
        if (cropper) {
          if (isEdit || colleagueId) {
            this.form.photo = photo.id
            cropper.previewSrc = photo.url
          } else {
            const proxiedPhoto = proxyPhoto
              ? await this.getProxiedPhoto(photo)
              : photo
            if (proxiedPhoto)
              cropper.img = { src: proxiedPhoto, name: photo.name }
          }
        }
      }

      const { studentPhoto } = prev.attributes || {}
      if (studentPhoto) {
        const [res, err] = await this.$api.upload.getProxiedFile(studentPhoto.url)
        if (err) console.error(err)
        else if (res) {
          try {
            const studentPhotoB64 = await fileToBase64(res)
            this.form.attributes.studentPhoto = {
              file: studentPhotoB64,
              name: studentPhoto.name,
            }
          } catch (e) { console.error(e) }
        }
      }

      const { oauth } = prev
      if (oauth) curr.oauth = oauth
    },

    async fillFromPreviousUserData () {
      await this.fill(this.previousData)
      this.$emit("update:previousData", null)
    },
    async fillFromOauthData (data) {
      await this.fill(data, true)
    },
    async fillFromUser () {
      await this.fill(this.user)
    },

    async login (token) {
      await this.$auth.setUserToken(token)
      window.location.href = this.localePath("/account")
      // this.$router.push(this.localePath("/account"))
      // this.$notifications.restart()
    },

    additionalValidate () {
      let isValid = true
      if (!this.form.interests.length) {
        this.$set(this.apiErr, "interests", this.$t("registration.selectInterests"))
        isValid = false
      }
      if (!this.form.photo) {
        this.$set(this.apiErr, "photo", this.$t("registration.selectPhoto"))
        isValid = false
      }
      return isValid
    },

    async getProxiedPhoto (photoUrl) {
      try {
        const blob = await uploadApi(this.$axios).uploadProxy(encodeURI(photoUrl))
        return await fileToBase64(blob)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
        return null
      }
    },

    async onSubmit () {
      if (this.isLoading) return
      this.isLoading = true

      const userApi = this.$api.user
      const { isEdit, isColleague } = this
      const payload = this.getPayload()
      let promise

      if (isEdit) promise = this.updateUser(payload)
      else if (isColleague) {
        const { colleagueId } = this
        if (colleagueId) promise = userApi.updateColleague(colleagueId, payload)
        else promise = userApi.createColleague(payload)
      } else promise = userApi.createUser(payload)

      const [res, err] = await promise
      if (err) {
        const apiErr = err
        if (apiErr) this.apiErr = apiErr
        else console.error(err)
        this.isLoading = false
        return
      }

      if (isEdit) this.$router.push(this.localePath("/account"))
      else if (isColleague) this.$router.push(this.localePath("/account/payment"))
      else {
        window.ym?.(this.$config.yandexMetrika.id, "reachGoal", "registration_success")
        window._tmr?.push({ type: "reachGoal", id: this.$config.tmr.id, goal: "registration_success" })
        await this.login(res.token)
      }

      this.isLoading = false
    },

    async fetchColleagueData () {
      const { colleagueId } = this
      if (!colleagueId) return
      const [res, err] = await this.$api.user.getColleague(colleagueId)
      if (err) {
        console.error(err)
        return
      }
      await this.fill(res || {})
    },

    updateSkData: debounce(async function () {
      const fail = () => {
      }

      const { inn } = this.form.attributes
      if (!inn) return fail()

      const [res, err] = await this.$api.exhibition.getSkData(inn)
      if (err || !res) {
        fail()
        if (err) console.error(err)
        return
      }

      const { Result = "0" } = res
      if (Result === "0") return fail()

      this.form.status = "skresident"
      this.form.attributes.skOrn = res.Orn
      this.form.company.ru = res.Name
      this.form.attributes.skCompany = res.Name
    }, 300),
  },
}
